<template>
    <div class="config-form-content weeduc-admin-config adminWeeducConfig weflix-admin-layoutBasic">
      <div class="row g-3 g-lg-4 weeduc-admin-config-layout mx-0" v-if="hasReady">
        <div class="col-12 col-lg-6 weeduc-admin-config-col">
          <div class="weeduc-admin-config-section">
            <h3 class="weeduc-admin-config-section-title">Informações do site</h3>
            <p class="weeduc-admin-config-section-lead">Título, descrição e contato exibidos no site.</p>

            <div class="form-group">
              <label class="form-label" for="weflixBasicTitle">Título do site</label>
              <input
                id="weflixBasicTitle"
                type="text"
                required
                class="form-input"
                v-model="name"
                placeholder="Título do seu site"
              />
              <small class="form-small-description weflix-field-error" v-if="error[0]">Campo obrigatório e deve ser preenchido corretamente.</small>
            </div>

            <div class="form-group">
              <label class="form-label" for="weflixBasicDescription">Descrição</label>
              <textarea id="weflixBasicDescription" class="form-input" v-model="description"></textarea>
              <small class="form-small-description weflix-field-error" v-if="error[1]">Campo obrigatório e deve ser preenchido corretamente.</small>
            </div>

            <div class="form-group">
              <label class="form-label" for="weflixBasicAbout">Descrição sobre</label>
              <textarea id="weflixBasicAbout" class="form-input" v-model="descriptionAbout"></textarea>
            </div>

            <div class="form-group weeduc-admin-config-field-status">
              <v-select
                v-model="contentWarning"
                :items="contentWarningOptions"
                item-title="text"
                item-value="value"
                label="Aviso de conteúdo sensível"
                variant="outlined"
                class="filter-form-control inputd weeduc-admin-v-field"
                density="compact"
                hide-details
              />
              <small class="form-small-description">Exibir aviso de conteúdo sensível no site</small>
            </div>

            <div class="form-group">
              <label class="form-label" for="weflixBasicPhone">WhatsApp</label>
              <input
                id="weflixBasicPhone"
                type="text"
                inputmode="tel"
                autocomplete="tel"
                class="form-input"
                v-model="phone"
                v-mask="['(##) ####-####', '(##) #####-####']"
                placeholder="(11) 99999-9999"
              />
              <small class="form-small-description">DDD + número. Ao salvar, o código do país 55 é acrescentado automaticamente quando necessário.</small>
            </div>
          </div>
        </div>
        <div class="col-12 col-lg-6 weeduc-admin-config-col">
          <div class="weeduc-admin-config-section">
            <h3 class="weeduc-admin-config-section-title">Identidade visual</h3>
            <p class="weeduc-admin-config-section-lead">Logo e favicon usados no site e na aba do navegador.</p>

            <div class="form-group">
              <label class="form-label">Logo</label>
              <span class="weeduc-admin-config-hint">Imagem maior que 120x60 pixels</span>
              <div class="form-file weeduc-admin-file-zone">
                <div class="file-wrapper primary weeduc-admin-file-wrapper">
                  <img
                    :src="logoPreview ? logoPreview : logo"
                    alt="Logo"
                    v-show="logoPreview || logo"
                    class="image-preview weeduc-admin-logo-preview"
                  />
                  <span class="thumbnail" v-if="!logoPreview && !logo">
                    <span class="text" v-if="loaderImage">Clique aqui para selecionar a imagem</span>
                    <LoaderImage :hasReady="loaderImage"/>
                  </span>
                  <input
                    class="form-control weeduc-admin-file-input"
                    type="file"
                    @change="updateFilePathLogo"
                    accept=".png, .jpg, .jpeg, .webp"
                  />
                </div>
              </div>
            </div>

            <div class="form-group">
              <label class="form-label">Favicon</label>
              <span class="weeduc-admin-config-hint">Imagem usada como ícone da aba do navegador</span>
              <div class="form-file weeduc-admin-file-zone weeduc-admin-file-zone--compact">
                <div class="file-wrapper primary weeduc-admin-file-wrapper">
                  <img
                    :src="faviconPreview ? faviconPreview : favicon"
                    alt="Favicon"
                    v-show="faviconPreview || favicon"
                    class="image-preview weeduc-admin-favicon-preview"
                  />
                  <span class="thumbnail" v-if="!faviconPreview && !favicon">
                    <span class="text" v-if="loaderImage">Clique aqui para selecionar a imagem</span>
                    <LoaderImage :hasReady="loaderImage"/>
                  </span>
                  <input
                    class="form-control weeduc-admin-file-input"
                    type="file"
                    @change="updateFilePathFavicon"
                    accept=".png, .jpg, .jpeg, .webp, .ico"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="buttons-container weeduc-admin-site-form-actions" v-if="hasReady">
        <div class="button d-flex flex-wrap gap-2 justify-content-end">
          <button type="button" class="btn btn-block btn-content" @click="updateWebsite" :disabled="!loaderImage">Salvar</button>
        </div>
      </div>
    </div>
  <Loader :hasReady="hasReady" />
</template>
<script>
import websiteApi from '@/utils/Weflix/website';
import apiAWS from '@/utils/storage/aws';
import { mapState, mapActions } from 'vuex';
import Loader from '@/components/Weflix/Loader.vue';
import LoaderImage from '@/components/Weflix/LoaderImage';
import { toast } from 'vue3-toastify';
import companyApi from '@/utils/Weflix/company';

export default {
  data() {
    return {
      description: '',
      logo: '',
      favicon: '',
      logoPreview: '',
      faviconPreview: '',
      id: '',
      error: [false, false],
      hasReady: false,
      facebook: '',
      gads: '',
      ganalytic: '',
      tagManager: '',
      rdrefreshToken: '',
      rdcode: '',
      rdSecret: '',
      rdClient: '',
      color: '',
      activeTheme: null,
      descriptionAbout: '',
      facebook: '',
      gads: '',
      ganalytic: '',
      tagManager: '',
      rdrefreshToken: '',
      rdcode: '',
      rdSecret: '',
      rdClient: '',
      loaderImage: true,
      logoChanged: false,      // <--- flag para saber se o logo foi alterado localmente
      faviconChanged: false,   // <--- flag para saber se o favicon foi alterado localmente
      contentWarning: '',
      contentWarningOptions: [
        { text: 'Selecione uma opção', value: '' },
        { text: 'Sim', value: '1' },
        { text: 'Não', value: '0' }
      ],
      infoCompany: {},
      phone: ''
    };
    },
    computed: {
        ...mapState(['token', 'layoutWebsite'])
    },
    components: {
        Loader,
        LoaderImage,
    },
    methods: {
      ...mapActions(['storeLayoutWebsite']),
        fillPreviewData() {
            const blank = (value) => value == null || String(value).trim() === '';
            if (blank(this.name)) this.name = 'Weflix Preview';
            if (blank(this.description)) {
                this.description = 'Plataforma de educação e treinamentos online para escolas e empresas.';
            }
            if (blank(this.descriptionAbout)) {
                this.descriptionAbout = 'Somos uma empresa de tecnologia focada em educação digital.';
            }
            if (blank(this.contentWarning)) this.contentWarning = '0';
            if (blank(this.phone)) this.phone = '(21) 99464-7568';
            if (!this.logoPreview && !this.logo) {
                this.logoPreview = this.buildPreviewImage({
                    width: 320,
                    height: 160,
                    background: '#250891',
                    label: 'LOGO',
                });
            }
            if (!this.faviconPreview && !this.favicon) {
                this.faviconPreview = this.buildPreviewImage({
                    width: 128,
                    height: 128,
                    background: '#4682B4',
                    label: 'F',
                });
            }
        },
        buildPreviewImage({ width, height, background, label }) {
            const canvas = document.createElement('canvas');
            canvas.width = width;
            canvas.height = height;
            const ctx = canvas.getContext('2d');
            ctx.fillStyle = background;
            ctx.fillRect(0, 0, width, height);
            ctx.fillStyle = '#ffffff';
            ctx.font = `bold ${Math.floor(height * 0.28)}px sans-serif`;
            ctx.textAlign = 'center';
            ctx.textBaseline = 'middle';
            ctx.fillText(label, width / 2, height / 2);
            return canvas.toDataURL('image/png');
        },
        async getWebsite() {
            const response = await websiteApi.getWebsite(this.token);
            this.storeLayoutWebsite({ layoutWebsite: response });

            // Atribuindo todos os campos retornados pela API
            this.id = this.layoutWebsite.id;
            this.name = this.layoutWebsite.nome;
            this.title = this.layoutWebsite.title;
            this.url = this.layoutWebsite.url;
            this.url1 = this.layoutWebsite.url1;
            this.url2 = this.layoutWebsite.url2;
            this.description = this.layoutWebsite.description;
            this.keywords = this.layoutWebsite.keywords;
            this.logo = this.layoutWebsite.logo;
            this.logoPreview = this.layoutWebsite.logoFinal;
            this.favicon = this.layoutWebsite.favicon;
            this.faviconPreview = this.layoutWebsite.faviconFinal;
            this.color = this.layoutWebsite.color;
            this.status = this.layoutWebsite.status;
            this.tagManager = this.layoutWebsite.tagManagerCode;
            this.activeTheme = this.layoutWebsite.typeLayout;
            this.javascript = this.layoutWebsite.javascript;
            this.css = this.layoutWebsite.css;
            this.typeLayoutPortal = this.layoutWebsite.typeLayoutPortal;
            this.ganalytic = this.layoutWebsite.googleAnalyticsCode;
            this.gads = this.layoutWebsite.googleAdsCode;
            this.facebook = this.layoutWebsite.facebookPixelCode;
            this.dateInsert = this.layoutWebsite.dateInsert;
            this.email = this.layoutWebsite.email;
            this.phone = this.formatPhoneDisplay(this.layoutWebsite.phone);
            this.numberCollection = this.layoutWebsite.numberCollection;
            this.numberVideo = this.layoutWebsite.numberVideo;
            this.timeVideo = this.layoutWebsite.timeVideo;
            this.numberSubscription = this.layoutWebsite.numberSubscription;
            this.descriptionAbout = this.layoutWebsite.about;
            this.termUse = this.layoutWebsite.termUse;
            this.typeImageCoverCourse = this.layoutWebsite.typeImageCoverCourse;
            this.visibleTitleCourse = this.layoutWebsite.visibleTitleCourse;
            this.rdSecret = this.layoutWebsite.rdsecretClient;
            this.rdClient = this.layoutWebsite.rdclienteId;
            this.rdcode = this.layoutWebsite.rdcode;
            this.rdrefreshToken = this.layoutWebsite.rdrefreshToken;

            // Resetar flags de alteração de logo/favicon ao carregar do servidor
            this.logoChanged = false;
            this.faviconChanged = false;

            this.hasReady = true;
        },
        async getInfoCompany() {
      try {
        const response = await companyApi.getCompany(this.token);
        this.infoCompany = response;
        this.contentWarning = response.ageRestricted !== undefined && response.ageRestricted !== null ? String(response.ageRestricted) : '';
      } catch (error) {
        toast.error('Erro ao obter dados da empresa');
      }
    },
    async setInfoCompany() {
      try {
        const payload = {
          ...this.infoCompany,
          ageRestricted: this.contentWarning !== '' ? parseInt(this.contentWarning) : null
        };
        const response = await companyApi.editCompany(this.token, payload);
      
        toast.success('Dados da empresa salvos com sucesso!');
      } catch (error) {
        toast.error('Erro ao salvar dados da empresa');
        console.error('Erro ao salvar dados da empresa:', error);
      }
    },
        async updateWebsite() {
            if (this.verifyFields()) {
                this.hasReady = false;

                // Garante que, se o usuário não fez upload local, o valor enviado é o do servidor
                // Se fez upload local, o valor já está atualizado nos campos logo/logoPreview e favicon/faviconPreview
                const payload = {
                    "nome": this.name,
                    "title": this.title,
                    "url": this.url,
                    "url1": this.url1,
                    "url2": this.url2,
                    "description": this.description,
                    "keywords": this.keywords,
                    "logo": this.logoChanged ? this.logo : this.layoutWebsite.logo, // sobrescreve só se mudou localmente
                    "logoFinal": this.logoChanged ? this.logoPreview : this.layoutWebsite.logoFinal,
                    "favicon": this.faviconChanged ? this.favicon : this.layoutWebsite.favicon,
                    "faviconFinal": this.faviconChanged ? this.faviconPreview : this.layoutWebsite.faviconFinal,
                    "color": this.color,
                    "status": this.status,
                    "tagManagerCode": this.tagManager,
                    "typeLayout": this.activeTheme,
                    "javascript": this.javascript,
                    "css": this.css,
                    "typeLayoutPortal": this.typeLayoutPortal,
                    "googleAnalyticsCode": this.ganalytic,
                    "googleAdsCode": this.gads,
                    "facebookPixelCode": this.facebook,
                    "dateInsert": this.dateInsert,
                    "email": this.email,
                    "phone": this.normalizePhoneForApi(this.phone),
                    "numberCollection": this.numberCollection,
                    "numberVideo": this.numberVideo,
                    "timeVideo": this.timeVideo,
                    "numberSubscription": this.numberSubscription,
                    "about": this.descriptionAbout,
                    "termUse": this.termUse,
                    "typeImageCoverCourse": this.typeImageCoverCourse,
                    "visibleTitleCourse": this.visibleTitleCourse,
                    "rdsecretClient": this.rdSecret,
                    "rdclienteId": this.rdClient,
                    "rdcode": this.rdcode,
                    "rdrefreshToken": this.rdrefreshToken
                };
                try {
                  if (this.contentWarning !== '') {
                    await this.setInfoCompany();
                  }
                    const response = await websiteApi.editWebsite(this.token, this.id, payload);
                    this.getWebsite();
                    this.clearCache();
                    this.hasReady = true;
                    this.notify('Dados atualizados com sucesso!', 'success');
                } catch (error) {
                    this.notify('Erro ao atualizar dados do website.', 'error');
                    console.error('Erro ao atualizar dados do website:', error);
                }
            }
        },
        formatPhoneDisplay(raw) {
            if (raw == null || raw === '') return '';
            let d = String(raw).replace(/\D/g, '');
            if (d.startsWith('55') && d.length >= 12) {
                d = d.slice(2, 13);
            }
            if (d.length > 11) d = d.slice(0, 11);
            if (d.length === 0) return '';
            if (d.length <= 2) return `(${d}`;
            if (d.length <= 6) return `(${d.slice(0, 2)}) ${d.slice(2)}`;
            if (d.length <= 10) {
                return `(${d.slice(0, 2)}) ${d.slice(2, 6)}-${d.slice(6)}`;
            }
            return `(${d.slice(0, 2)}) ${d.slice(2, 7)}-${d.slice(7, 11)}`;
        },
        normalizePhoneForApi(value) {
            if (value == null || String(value).trim() === '') {
                return null;
            }
            let digits = String(value).replace(/\D/g, '');
            if (!digits) return null;
            if (!digits.startsWith('55') && digits.length >= 10 && digits.length <= 11) {
                digits = `55${digits}`;
            }
            return digits;
        },
        verifyFields() {
            if (!this.name) {
                this.error[0] = true; 
                return false;
            }
            if (!this.description) {
              this.error[1] = true;
              return false;
            }
            return true;
        },
        async clearCache(){
        try {
          const response = await websiteApi.clearCache(this.token);
          this.messageStatusCache = true;
        } catch (error) {
          console.error('Erro ao limpar cache', error);
        }
      },
        async putFileAws(url, file){
          try {
              const response = await apiAWS.putFileAWS(url, file);
          } catch (error) {
              console.error('Erro ao enviar arquivo para AWS');
          }
        },
        async updateFilePathLogo(event){
            this.loaderImage = false;
            const file = event.target.files[0];
            this.logoPreview = URL.createObjectURL(file);
            try {
                const response =  await apiAWS.getSignatureImage(this.token, file.name);
                this.putFileAws(response.url, file);
                this.logo = response.token;
                this.logoChanged = true; // Marca que o logo foi alterado localmente
                this.loaderImage = true;
            } catch (error) {
                console.error('Erro na geração do TOKEN AWS')
            }
        },
        async updateFilePathFavicon(event){
            this.loaderImage = false;
            const file = event.target.files[0];
            this.faviconPreview = URL.createObjectURL(file);
            try {
                const response =  await apiAWS.getSignatureImage(this.token, file.name);
                this.putFileAws(response.url, file);
                this.favicon = response.token;
                this.faviconChanged = true; // Marca que o favicon foi alterado localmente
                console.debug(response);
                this.loaderImage = true;
              } catch (error) {
                console.error('Erro na geração do TOKEN AWS')
            }
        },
        notify(message, type = "info") {
            toast(message, {
                autoClose: 3000,
                position: 'top-right',
                theme: "light", 
                limit: 1,
                type: type,
                dangerouslyHTMLString: true
            });
        },
    },
    created() {
        this.getWebsite();
        this.getInfoCompany();
    }
  }
</script>

<style scoped>
@import '@/css/weeduc/admin/config.css';

.weflix-field-error {
    color: #b42318;
    display: block;
}

.btn-content:disabled {
    opacity: 0.55;
    cursor: not-allowed;
}
</style>